module.exports = __webpack_public_path__ + "03_mid_brown.6b49c103.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_mid_brown.png
// module id = 1gOD
// module chunks = 0